import {
    getAllRouteByTokenLoading,
    getAllRouteByTokenSuccess,
    getAllRouteByTokenReject,
    getAllRouteByTokenRequest
} from "../../actions/home/getAllOnRoutesByToken";

export const getAllOnRoutesByToken = (token) => async (dispatch) => {
    dispatch(getAllRouteByTokenLoading());
    try {
        const { data } = await getAllRouteByTokenRequest(token);
        dispatch(getAllRouteByTokenSuccess(data))
    } catch (error) {
        dispatch(getAllRouteByTokenReject(error))
    }
    return Promise.resolve();
};
